import { render } from "./SendMessageModal.vue?vue&type=template&id=4494e867&ts=true"
import script from "./SendMessageModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__